import React, { useMemo } from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { useFilterBarValues } from '../FilterBar.context'
import { FilterDropdown } from './FilterDropdown'
import { DropdownItemType, NestedFilterType } from './FilterDropdown.constants'

export const CitationTypesFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    const { values } = useFilterBarValues()

    const filterValues = useMemo(() => {
      const citationTypes = values.citationTypes || []
      const groups: Record<string, string[]> = {}
      citationTypes.forEach((val) => {
        const itemVal = typeof val === 'string' ? val : val.value
        if (itemVal === 'No Citation') {
          if (!groups['No Citation']) groups['No Citation'] = []
          groups['No Citation'].push('No Citation')
        } else {
          const idx = itemVal.indexOf(':')
          if (idx !== -1) {
            const category = itemVal.substring(0, idx).trim()
            if (!groups[category]) groups[category] = []
            groups[category].push(itemVal)
          } else {
            if (!groups[itemVal]) groups[itemVal] = []
            groups[itemVal].push(itemVal)
          }
        }
      })

      const items: DropdownItemType[] = []

      Object.entries(groups).forEach(([category, values]) => {
        const hasColon = values.some((val) => val.indexOf(':') !== -1)
        if (!hasColon) {
          values.forEach((val) => {
            items.push({
              value: val,
              label: val,
            })
          })
          return
        }

        const nestedFilter: NestedFilterType = {
          filterParam: category,
          filterValues: values.map((val) => {
            const idx = val.indexOf(':')
            const label = idx !== -1 ? val.substring(idx + 1).trim() : val
            return {
              value: val,
              label,
            }
          }),
        }

        items.push({
          value: category,
          label: category,
          nestedFilter,
        })
      })

      return items
    }, [values.citationTypes])

    return (
      <FilterDropdown
        filterParam={FilterParam.CITATION_TYPES}
        filterName={FilterName.CITATION_TYPES}
        filterValues={filterValues}
        parentMeansAll
        isNested={isNested}
      />
    )
  },
)
